const HTMLText = ({ html, className }) => {
  return (
    <span
      className={className}
      dangerouslySetInnerHTML={{
        __html: html,
      }}
    ></span>
  )
}

export default HTMLText
